<template>
    <div :class="[inputCssClass, errorMessages ? 'field-error' : '']">
        <div class="global-label">{{ label }}</div>
        <div>
            <v-menu
                v-model="menuOpen"
                :transition="false"
                offset-y
                right
                :close-on-content-click="false"
            >
                <template v-slot:activator="{ on }">
                    <div tabindex="0" class="disp cursor-pointer" v-on="on">
                        <div v-if="value.length > 0" class="d-flex">
                            <div class="val ml-2 pr-1">{{ valueDisp }}</div>
                        </div>
                        <div v-else>
                            <div class="val ml-2" style="color: var(--v-n4-base);">
                                {{ fieldEmptyText }}
                            </div>
                            <div :class="['arrow', menuOpen ? 'arrow--open' : '']"><icon icon="ChevronDown" small /></div>
                        </div>
                    </div>
                </template>
                <v-card>
                    <v-text-field
                        ref="filterBox"
                        v-model="keyword"
                        :placeholder="$t('Search tasks...')"
                        hide-details
                        class="menu-filter-text mt-0 pt-0 body-2"
                        @input="$emit('filterTasks', $event)"
                        @keypress.enter.esc="$emit('tab_next')"
                    ></v-text-field>
                    <v-list dense style="max-height: 500px; max-width: 273px; overflow: auto;">
                        <v-list-item
                            v-for="item in filteredList"
                            :key="item.id"
                            style="min-height: 32px;"
                            @click="toggleSelection($event, item.id)"
                        >
                            <v-list-item-content>
                                <v-list-item-title class="font-weight-regular subtitle-2">
                                    {{ item.title }}
                                </v-list-item-title>
                                <v-list-item-subtitle class="g4--text caption">
                                    <span v-if="getItemDate(item)">{{ getItemDate(item) }}</span>
                                    <span v-if="getItemDate(item) && item.assignees.length"> - </span>
                                    <span v-if="item.assignees.length">
                                        <PersonAvatar
                                            v-for="(person, index) in item.assignees"
                                            :size="24"
                                            :key="index"
                                            :person="person"
                                        />
                                    </span>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action>
                                <icon
                                    v-if="taskIdCol.indexOf(item.id) >= 0"
                                    color="primary"
                                    icon="Check"
                                />
                            </v-list-item-action>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-menu>

            <div :class="['details', errorMessages ? 'error--text' : '']">
                {{ errorMessages }}
            </div>
        </div>
    </div>
</template>

<script>
import { ref, computed, watch } from "@vue/composition-api";
import { deepClone } from "../helpers/helpers";
import { $t } from "@/i18n";
import { parseSysDate } from "../plugins/formatting";
import PersonAvatar from "@/components/PersonAvatar";

export default {
    name: "RelatedTaskField",
    components: {PersonAvatar},
    props: {
        label: {
            type: String,
            default: null
        },
        value: {
            type: Array,
            required: true
        },
        taskId: {
            type: [Number, String],
            required: true
        },
        items: {
            type: Array,
            required: true
        },
        errorMessages: {
            type: String,
            default: null
        },
        inputCssClass: {
            type: String,
            default: "task-field"
        },
        fieldEmptyText: {
            type: String,
            default: ""
        }
    },
    setup(props, ctx) {
        const menuOpen = ref(false);
        const keyword = ref(null);
        const taskIdCol = ref([]);
        const filterBox = ref(null);

        const filteredList = computed(function() {
            let size = 50;
            if (!keyword.value) return props.items.filter(x => x.id !== props.taskId).slice(0, size);
            let key = keyword.value.toLowerCase();
            return props.items
                .filter(x => x.title.toLowerCase().indexOf(key) >= 0)
                .filter(x => x.id !== props.taskId)
                .slice(0, size);
        });
        const valueDisp = computed(() => {
            if (taskIdCol.value == null || taskIdCol.value.length === 0) return "";
            return taskIdCol.value.map(x => {
                let item = props.items.find(y => y.id === x);
                if (item == null) return null;
                return (item.title.length < 25) ? item.title : (item.title.substr(0, 23) + "...");
            }).filter(x => x != null).join(", ");
        });
        /*const watchValue = computed(() => {
            return props.value;
        });*/

        const loadData = () => {
            taskIdCol.value = props.value === undefined || props.value == null ? [] : deepClone(props.value);
        }
        const toggleSelection = (e, id) => {
            let pos = taskIdCol.value.indexOf(id);
            if (pos >= 0)
                taskIdCol.value.splice(pos, 1);
            else
                taskIdCol.value.push(id);
        };

        /*watch(watchValue, (val) => {
            //taskIdCol.value = val != null ? val : [];
        });*/
        watch(menuOpen, (val, prev_val) => {
            if (prev_val === undefined) return;
            if (val) {
                loadData()

                setTimeout(() => {
                    filterBox.value.focus();
                }, 200);
            }
            else if (!Array.equalValues(props.value, taskIdCol.value)) {
                ctx.emit("change", taskIdCol.value);
            }
        });

        // If a virtual task is created into a real task then we need to load taskIdCol again
        watch(() => props.taskId, () => {
            loadData()
        })

        const getItemDate = (item) => {
            if (item.recurrence_rule) {
                return
            }

            if (item.date) {
                return parseSysDate(item.date).formatDate()
            }

            return null
        }

        loadData();

        return {
            menuOpen,
            keyword,
            filteredList,
            valueDisp,
            taskIdCol,
            filterBox,
            toggleSelection,
            getItemDate
        };
    }
}
</script>